import { InfoIcon } from 'lucide-react';

interface LandingsDisabledBannerProps {
	reason: 'disabled' | 'token';
}

export function LandingsDisabledBanner({ reason }: LandingsDisabledBannerProps) {
	const message =
		reason === 'disabled'
			? 'Модуль лендингов отключён администратором.'
			: 'Не удалось получить доступ к API лендингов. Проверьте, что модуль включён и VITE_LANDINGS_URL настроен.';

	return (
		<div className='flex items-start gap-2 rounded-lg border border-border bg-muted/40 px-3 py-2.5 text-sm text-muted-foreground'>
			<InfoIcon className='mt-0.5 size-4 shrink-0' />
			<span>{message}</span>
		</div>
	);
}
